<template>
  <div style="background-color: white">
    <el-row style="padding-top: 10px">
      <el-col :span="24">
        <el-button
          size="small"
          class="btn"
          v-if="show.tj"
          type="primary"
          @click="handleCreate"
          >添加</el-button
        >
        <el-button
          size="small"
          class="btn"
          v-if="show.sh"
          type="primary"
          @click="selectshqx"
          >审核</el-button
        >
        <el-button
          size="small"
          class="btn"
          v-if="show.lr"
          type="primary"
          @click="selectlrqx"
          >维保录入</el-button
        >
        <el-button
          size="small"
          @click="selectQx"
          v-if="show.qr"
          class="btn"
          type="primary"
          >维保确认</el-button
        >
        <el-button
          size="small"
          type="primary"
          v-if="show.dctz"
          class="btn"
          @click="derive"
          >导出列表</el-button
        >
        <el-form
          :inline="true"
          ref="deviceInfo"
          :model="deviceInfo"
          class="demo-form-inline"
          style="float: right !important"
        >
        <el-form-item label="筛选单位">
            <el-cascader
            v-model="deviceInfo.companyCode" 
              :options="companyTree"
              :show-all-levels="false"
              :props="props"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item :label="lable.statue">
            <el-select
              v-model="deviceInfo.state"
              filterable
              clearable
              :placeholder="'请选择' + lable.statue"
              style="width: 120px"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker
              v-model="deviceInfo.date"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="模糊搜索">
            <el-input
              v-model="deviceInfo.content"
              auto-complete="off"
              placeholder="请输入搜索内容"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="findAllClick"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
          :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }"
          ref="multipleTable"
          :data="maintenanceData"
          tooltip-effect="dark"
          :row-key="getRowKeys"
          @selection-change="changeCheckBoxValue"
          style="width: 100%; text-align: center"
          stripe
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            width="55"
          >
          </el-table-column>
          <el-table-column
            :label="lable.index"
            type="index"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="id"
            :label="lable.id"
            width="170"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-link
                :underline="false"
                @click="onClick(scope.row)"
                style="color: #4095e5; text-decoration: none"
              >
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="glbh"
            :label="lable.glbh"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="zcmc"
            :label="lable.zcmc"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="ssdw"
            :label="lable.ssdw"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="applyTime"
            :label="lable.applyTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="userName"
            :label="lable.userName"
            width="100PX"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="companyName"
            :label="lable.companyName"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="reason"
            :label="lable.reason"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="wz"
            :label="lable.statue"
            width="100PX"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.statue == '1'"
                style="color: #4095e5"
                v-text="scope.row.wz"
              ></span>
              <span
                v-else-if="scope.row.statue == '2'"
                style="color: gray"
                v-text="scope.row.wz"
              ></span>
              <span
                v-else-if="scope.row.statue == '3'"
                style="color: yellowgreen"
                v-text="scope.row.wz"
              ></span>
              <span
                v-else-if="scope.row.statue == '4'"
                style="color: orange"
                v-text="scope.row.wz"
              ></span>
              <span
                v-else-if="scope.row.statue == '5'"
                style="color: rgb(204, 169, 13)"
                v-text="scope.row.wz"
              ></span>

              <span
                v-else-if="scope.row.statue == '0'"
                style="color: red"
                v-text="scope.row.wz"
              ></span>
              <span
                v-else-if="scope.row.statue == '1.5'"
                style="color: #4095e5"
                v-text="scope.row.wz"
              ></span>
            </template>
          </el-table-column>
          <el-table-column
            prop="evaluate"
            :label="lable.evaluate"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-rate
                v-if="scope.row.statue == '4'"
                v-model="scope.row.evaluate"
                style="width: 100%"
                :disabled="true"
                show-text
                :texts="pj"
              >
              </el-rate>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            :label="lable.remark"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column :label="lable.cz" width="200">
            <template slot-scope="scope">
              <el-button
                v-if="
                  (scope.row.statue == '0' || scope.row.statue == '1.5') 
                  // (scope.row.statue == '0' || scope.row.statue == '1.5') 
                  // &&
                  // show.xg
                  &&
                  (scope.row.applicant == userinfo.id)
                "
                @click="updateClick(scope.row)"
                type="text"
                size="small"
                >更改</el-button
              >
              <el-button
                v-if="
                  ((scope.row.statue == '0' || scope.row.statue == '1.5') &&
                    show.sc &&
                    scope.row.applicant == userinfo.id) ||
                  show.qjsc
                "
                @click="delMaintenance(scope.row)"
                type="text"
                size="small"
                >删除</el-button
              >
              <el-button
                v-if="
                  scope.row.statue == '1.5' &&
                  show.ch &&
                  scope.row.applicant == userinfo.id
                "
                @click="withdrawMaintenance(scope.row)"
                type="text"
                size="small"
                >撤回</el-button
              >
              <el-button
                @click="selectClick(scope.row)"
                type="text"
                size="small"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination
          v-if="maintenanceData.length > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </el-row>
    <!--------------------------------------------------------------------添加弹框--------------------------------------------------------------------------------->
    <el-dialog
      :visible.sync="dialogFormVisible"
      title="维保添加"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      style="width: 90% !important; margin-left: 10%"
    >
      <el-form
        :model="questionForm"
        ref="dataForm"
        label-position="left"
        label-width="100px"
        style="width: 90%; margin-left: 5%"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item :label="lable.glbh">
              <el-input
                placeholder="请选择资产"
                style="width: 100%"
                :readonly="true"
                v-model="questionForm.glbh"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3" :push="1">
            <DC :transferValue="transferValue" :personInfo="1"></DC>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item :label="lable.ssdw">
              <el-input
                placeholder="请选择资产"
                :readonly="true"
                v-model="questionForm.ssdw"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.zcmc">
          <el-input
            :readonly="true"
            placeholder="请选择资产"
            style="width: 100%"
            v-model="questionForm.zcmc"
          />
        </el-form-item>
        <el-form-item label="申请类别">
          <el-radio-group v-model="questionForm.maintenanceType">
            <el-radio label="0">维修</el-radio>
            <el-radio label="1">保养</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="lable.reason">
          <el-input
            :placeholder="'请输入' + lable.reason"
            style="width: 100%"
            v-model="questionForm.reason"
          />
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table
            :data="fileData"
            :border="true"
            style="width: 100%; text-align: center"
            size="mini"
            max-height="250"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column
              prop="createTime"
              label="上传日期"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot="header" slot-scope="scope">
                <el-button
                  type="text"
                  @click="innerVisible = true"
                  icon="el-icon-plus"
                  >增加
                </el-button>
              </template>
              <template slot-scope="scope">
                <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button> -->
                <el-button type="text" size="small" @click="DFile(scope.row)"
                  >删除</el-button
                >
                <el-button type="text" size="small" @click="yulan(scope.row)"
                  >预览</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="downloading(scope.row)"
                  >下载</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          style="margin-left: 10px"
          size="small"
          type="success"
          @click="submit"
          v-preventReClick
          >提交</el-button
        >
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
      <el-dialog
        width="30%"
        title="添加资料"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="innerVisible"
        append-to-body
      >
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="资料名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.fileDesc"></el-input>
          </el-form-item>
          <el-form-item label="选择">
            <el-upload
              class="upload"
              ref="upload"
              action="string"
              :file-list="fileList"
              :auto-upload="false"
              accept=".jpg,.npg,.png,.doc,.docx,.pdf,.xlsx"
              :http-request="uploadFile"
              :on-change="handleChange"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              multiple="multiple"
            >
              <el-button
                slot="trigger"
                size="small"
                type="primary"
                @click="delFile"
                >选取文件</el-button
              >
            </el-upload>

            <span>上传文件只能是jpg,png,npg,doc,docx,pdf,xlsx格式</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" v-preventReClick
              >上传</el-button
            >
            <el-button @click="innerVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
    <!------------------------------------------------------------------------修改弹框--------------------------------===========================================----------------------->
    <el-dialog
      :visible.sync="dialogFormVisible1"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      title="更改信息"
      style="width: 90% !important; margin-left: 10%"
    >
      <el-form
        :model="questionForm"
        ref="dataForm"
        label-position="left"
        label-width="100px"
        style="width: 90%; margin-left: 5%"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.glbh" style="width: 90%">
              <el-input
                :readonly="true"
                placeholder="请选择资产"
                style="width: 100%"
                v-model="questionForm.glbh"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.zcmc">
              <el-input
                :readonly="true"
                placeholder="请选择资产"
                style="width: 100%"
                v-model="questionForm.zcmc"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.ssdw">
          <el-input
            :readonly="true"
            placeholder="请选择资产"
            style="width: 100%"
            v-model="questionForm.ssdw"
          />
        </el-form-item>
        <el-form-item label="申请类别">
          <el-radio-group v-model="questionForm.maintenanceType">
            <el-radio label="0">维修</el-radio>
            <el-radio label="1">保养</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="lable.reason">
          <el-input
            placeholder="请输入原因"
            style="width: 100%"
            v-model="questionForm.reason"
          />
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table
            :data="fileData"
            :border="false"
            style="width: 100%; text-align: center"
            size="mini"
            max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column
              prop="createTime"
              label="上传日期"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot="header" slot-scope="scope">
                <el-button
                  type="text"
                  @click="innerVisible1 = true"
                  icon="el-icon-plus"
                  >增加
                </el-button>
              </template>
              <template slot-scope="scope">
                <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button> -->
                <el-button type="text" size="small" @click="DFile(scope.row)"
                  >删除</el-button
                >
                <el-button type="text" size="small" @click="yulan(scope.row)"
                  >预览</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="downloading(scope.row)"
                  >下载</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          style="margin-left: 10px"
          size="small"
          type="success"
          @click="submitUpdate"
          v-preventReClick
          >提交</el-button
        >
        <el-button @click="cancel1">取消</el-button>
      </div>
      <el-dialog
        width="30%"
        title="添加资料"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="innerVisible1"
        append-to-body
      >
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="资料名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.fileDesc"></el-input>
          </el-form-item>
          <el-form-item label="选择">
            <el-upload
              class="upload"
              ref="upload"
              action="string"
              :file-list="fileList"
              :auto-upload="false"
              accept=".jpg,.npg,.png,.doc,.docx,.pdf,.xlsx"
              :http-request="uploadFile"
              :on-change="handleChange"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              multiple="multiple"
            >
              <el-button
                slot="trigger"
                size="small"
                type="primary"
                @click="delFile"
                >选取文件</el-button
              >
            </el-upload>
            <span>上传文件只能是jpg,png,npg,doc,docx,pdf,xlsx格式</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit()" v-preventReClick
              >上传</el-button
            >
            <el-button @click="innerVisible1 = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
    <!------------------------------------------------------------------------维保详情弹框------------------------------------------------------->
    <el-dialog
      :visible.sync="dialogFormVisible2"
      title="维保详情"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      style="width: 100% !important; margin-left: 5%"
    >
      <el-form
        :model="questionForm"
        ref="dataForm"
        size="mini"
        label-position="left"
        label-width="100px"
        style="width: 90%; margin-left: 5%"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.id" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.id" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.zcmc">
              <el-input
                :readonly="true"
                v-model="questionForm.zcmc"
              /> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.glbh" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.glbh" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.ssdw">
              <el-input
                :readonly="true"
                v-model="questionForm.ssdw"
              /> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="维保类别" style="width: 90%">
              <el-input
                v-if="questionForm.maintenanceType == '0'"
                :readonly="true"
                value="设备维修"
              />
              <el-input
                v-else-if="questionForm.maintenanceType == '1'"
                :readonly="true"
                value="设备保养"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.applyTime">
              <el-input :readonly="true" v-model="questionForm.applyTime" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.userName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.companyName">
              <el-input
                placeholder=""
                :readonly="true"
                v-model="questionForm.companyName"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.reason" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.reason" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.wbr">
              <el-input :readonly="true" v-model="questionForm.wbrxm" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.tel" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.personTel" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.maintainMany">
              <el-input :readonly="true" v-model="questionForm.maintainMany" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.startTime" style="width: 90%">
              <el-date-picker
                v-model="questionForm.startTime"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                width="100%"
                :readonly="true"
                type="date"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.endTime">
              <el-date-picker
                v-model="questionForm.endTime"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                width="100%"
                :readonly="true"
                type="date"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.equipment" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.equipment" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.project">
              <el-input :readonly="true" v-model="questionForm.project" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="维保结果" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.result" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="需检定/校准">
              <el-radio-group
                v-model="questionForm.isCheck"
                :disabled="true"
                style="width: 100%"
              >
                <el-input
                  :readonly="true"
                  v-if="questionForm.isCheck == '0'"
                  value="需要"
                />
                <el-input
                  :readonly="true"
                  v-else-if="questionForm.isCheck == '1'"
                  value="不需要"
                />
                <el-input
                  :readonly="true"
                  v-if="
                    (questionForm.isCheck != '0') &
                    (questionForm.isCheck != '1')
                  "
                  value="维保未确认"
                />
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="维保记录">
              <el-input
                :readonly="true"
                type="textarea"
                :rows="2"
                v-model="questionForm.wbjl"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="lable.processReson">
              <el-input
                type="textarea"
                :readonly="true"
                :rows="2"
                v-model="questionForm.processReson"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-tabs v-model="activeName">
          <el-tab-pane label="业务信息" name="first">
            <el-table
              :data="tableData"
              :border="false"
              style="width: 90%; margin-left: 20px; text-align: center"
              size="mini"
              :header-cell-style="{
                textAlign: 'center',
                background: '#eff3f6',
              }"
              :cell-style="{ textAlign: 'center' }"
              max-height="235px"
            >
              <el-table-column label="序号" type="index" show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="时间"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="nodeName"
                label="事件"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="workflowResult"
                label="审批结果"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column prop="bz" label="审核意见" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="ssdw" label="单位" show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="userId"
                label="操作人"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="附加资料" name="second">
            <el-table
              :data="fileData"
              :border="false"
              style="width: 90%; margin-left: 20px; text-align: center"
              size="mini"
              :header-cell-style="{
                textAlign: 'center',
                background: '#eff3f6',
              }"
              :cell-style="{ textAlign: 'center' }"
              max-height="235px"
            >
              <el-table-column label="序号" type="index" show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="id" v-if="false"> </el-table-column>
              <el-table-column
                prop="name"
                label="资料名称"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="上传日期"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="fileDesc"
                label="备注"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="150px">
                <template slot-scope="scope">
                  <el-button @click="yulan(scope.row)" type="text" size="small"
                    >预览</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="downloading(scope.row)"
                    >下载</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="dialogFormVisible2 = false"
          type="primary"
          v-preventReClick
          >确认</el-button
        >
      </div>
    </el-dialog>
    <!--------------------------------------------------------------------维保审核弹框--------------------------------------------------------------------------------->
    <el-dialog
      :visible.sync="dialogFormVisible3"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="维保审核"
      style="width: 90% !important; margin-left: 200px"
    >
      <el-form
        :model="questionForm"
        ref="dataForm"
        label-position="left"
        label-width="100px"
        style="width: 90%; margin-left: 5%"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item style="width: 90%" :label="lable.id">
              <el-input :readonly="true" v-model="questionForm.id" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.glbh">
              <el-input :readonly="true" v-model="questionForm.glbh" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.ssdw" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.ssdw" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.userName">
              <el-input :readonly="true" v-model="questionForm.userName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.applyTime" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.applyTime" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.companyName">
              <el-input :readonly="true" v-model="questionForm.companyName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="维保类型">
          <el-input
            :readonly="true"
            v-if="questionForm.maintenanceType == '0'"
            value="设备维修"
          />
          <el-input
            :readonly="true"
            v-else-if="questionForm.maintenanceType == '1'"
            value="设备保养"
          />
        </el-form-item>
        <el-form-item :label="lable.reason">
          <el-input :readonly="true" v-model="questionForm.reason" />
        </el-form-item>
        <el-form-item label="业务流程">
          <el-table
            :data="tableData"
            :border="true"
            style="width: 100%; text-align: center"
            size="mini"
            max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="时间"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="nodeName" label="事件" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="workflowResult"
              label="审批结果"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="bz" label="审核意见" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ssdw" label="单位" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="userId" label="操作人" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item :label="lable.wbr" prop="list">
          <el-select
            v-model="questionForm.list"
            @change="selectChangeHandle"
            multiple
            style="width: 100%"
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionsUser"
              :key="item.userId"
              :label="item.userName"
              :value="item.userId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="lable.processReson">
          <el-input
            type="processReson"
            :rows="2"
            placeholder="请输入内容"
            v-model="questionForm.workflowContent"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          style="margin-left: 10px"
          type="primary"
          @click="auidt"
          v-preventReClick
          >通过</el-button
        >
        <el-button
          style="margin-left: 10px"
          type="danger"
          @click="noAuidt"
          v-preventReClick
          >驳回</el-button
        >
        <el-button @click="dialogFormVisible3 = false">取消</el-button>
      </div>
    </el-dialog>

    <!--------------------------------------------------------------------维保确认弹框--------------------------------------------------------------------------------->
    <el-dialog
      :visible.sync="dialogFormVisible4"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="维保确认"
      style="width: 100% !important; margin-left: 5%"
    >
      <el-form
        :model="questionForm"
        ref="dataForm"
        label-position="left"
        label-width="100px"
        style="width: 90%; margin-left: 5%"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.id" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.id" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.zcmc">
              <el-input
                :readonly="true"
                v-model="questionForm.zcmc"
              /> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.ssdw" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.ssdw" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.applyTime">
              <el-input :readonly="true" v-model="questionForm.applyTime" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.userName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.companyName">
              <el-input :readonly="true" v-model="questionForm.companyName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.reason" style="width: 90%">
              <el-input
                :readonly="true"
                :placeholder="'请输入' + lable.reason"
                v-model="questionForm.reason"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.wbr" prop="wbrxm">
              <el-input :readonly="true" v-model="questionForm.wbrxm" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.tel" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.personTel" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.maintainMany">
              <el-input :readonly="true" v-model="questionForm.maintainMany" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.startTime" style="width: 90%">
              <el-date-picker
                v-model="questionForm.startTime"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                width="100%"
                :readonly="true"
                type="date"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.endTime">
              <el-date-picker
                v-model="questionForm.endTime"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                width="100%"
                :readonly="true"
                type="date"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.equipment" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.equipment" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.project">
              <el-input :readonly="true" v-model="questionForm.project" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="维保结果" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.result" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="维保记录">
              <el-input
                :readonly="true"
                type="textarea"
                :rows="2"
                v-model="questionForm.wbjl"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.processReson">
          <el-input
            type="textarea"
            :readonly="true"
            :rows="2"
            placeholder="请输入内容"
            v-model="questionForm.processReson"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="附件资料">
          <el-table
            :data="fileData"
            :border="false"
            style="width: 100%; text-align: center"
            size="mini"
            max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="id" v-if="false"> </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="上传日期"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button @click="yulan(scope.row)" type="text" size="small"
                  >预览</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="downloading(scope.row)"
                  >下载</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="维保类别" style="width: 90%">
              <el-input
                v-if="questionForm.maintenanceType == '0'"
                :readonly="true"
                value="设备维修"
              />
              <el-input
                v-else-if="questionForm.maintenanceType == '1'"
                :readonly="true"
                value="设备保养"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="需检定/校准">
              <el-radio-group v-model="questionForm.sout" style="width: 100%">
                <el-radio label="0"> 需要</el-radio>
                <el-radio label="1">不需要</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.evaluate">
          <el-rate v-model="questionForm.evaluate" style="width: 100%">
          </el-rate>
        </el-form-item>
        <el-form-item :label="lable.remark">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="questionForm.remark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          style="margin-left: 10px"
          size="small"
          type="success"
          @click="submitNotarize"
          v-preventReClick
          >提交</el-button
        >
        <el-button @click="dialogFormVisible4 = false">取消</el-button>
      </div>
    </el-dialog>
    <!--------------------------------------------------------------------维保录入弹框--------------------------------------------------------------------------------->
    <el-dialog
      :visible.sync="dialogFormVisible5"
      title="维保录入"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width: 100% !important"
    >
      <el-form
        :model="questionForm"
        ref="dataForm"
        label-position="left"
        label-width="100px"
        style="width: 90%; margin-left: 5%"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.id" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.id" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="资产编号" style="width: 100%">
              <el-input :readonly="true" v-model="questionForm.deviceId" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.zcmc" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.zcmc" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.ssdw">
              <el-input :readonly="true" v-model="questionForm.ssdw" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.userName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.companyName">
              <el-input :readonly="true" v-model="questionForm.companyName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="维保类型" style="width: 90%">
              <span v-if="questionForm.maintenanceType == '0'"
                ><el-input :readonly="true" value="设备维修"
              /></span>
              <span v-else-if="questionForm.maintenanceType == '1'"
                ><el-input :readonly="true" value="设备保养"
              /></span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.maintainMany">
              <el-input
                :placeholder="'请输入' + lable.maintainMany"
                v-model="questionForm.maintainMany"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.wbr" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.wbrxm" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.tel">
              <el-input :readonly="true" v-model="questionForm.personTel" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.startTime" style="width: 90%">
              <el-date-picker
                v-model="questionForm.startTime"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                width="100%"
                type="date"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.endTime">
              <el-date-picker
                v-model="questionForm.endTime"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                width="100%"
                type="date"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.equipment" style="width: 90%">
              <el-input
                :placeholder="'请输入' + lable.equipment"
                v-model="questionForm.equipment"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.project">
              <el-input
                placeholder="请输入维修项目"
                v-model="questionForm.project"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="维保结果" style="width: 90%">
              <el-select
                v-model="questionForm.result"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in resultOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="维保记录">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="维保记录"
                v-model="questionForm.wbjl"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.processReson">
          <el-input
            type="textarea"
            :readonly="true"
            :rows="1"
            placeholder="请输入内容"
            v-model="questionForm.processReson"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table
            :data="fileData"
            style="width: 100%; text-align: center"
            size="mini"
            max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column
              prop="createTime"
              label="上传日期"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot="header" slot-scope="scope">
                <el-button
                  type="text"
                  @click="innerVisible2 = true"
                  icon="el-icon-plus"
                  >增加
                </el-button>
              </template>
              <template slot-scope="scope">
                <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button> -->
                <el-button type="text" size="small" @click="DFile(scope.row)"
                  >删除</el-button
                >
                <el-button type="text" size="small" @click="yulan(scope.row)"
                  >预览</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="downloading(scope.row)"
                  >下载</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          style="margin-left: 10px"
          size="small"
          type="success"
          @click="submitLuru"
          v-preventReClick
          >提交</el-button
        >
        <el-button @click="dialogFormVisible5 = false">取消</el-button>
      </div>
      <el-dialog
        width="30%"
        title="添加资料"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="innerVisible2"
        append-to-body
      >
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="资料名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.fileDesc"></el-input>
          </el-form-item>
          <el-form-item label="选择">
            <el-upload
              class="upload"
              ref="upload"
              action="string"
              :file-list="fileList"
              :auto-upload="false"
              accept=".jpg,.npg,.png,.doc,.docx,.pdf,.xlsx"
              :http-request="uploadFile"
              :on-change="handleChange"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              multiple="multiple"
            >
              <el-button
                slot="trigger"
                size="small"
                type="primary"
                @click="delFile"
                >选取文件</el-button
              >
            </el-upload>
            <span>上传文件只能是jpg,png,npg,doc,docx,pdf,xlsx格式</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" v-preventReClick
              >上传</el-button
            >
            <el-button @click="innerVisible2 = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
    <!-- 添加显示购物车按钮，如果复选框有选中让显示，否则不显示 -->
    <div
      style="
        position: fixed;
        top: 13%;
        left: 35%;
        height: 50px;
        width: 50px;
        color: #4095e5;
        font-size: 20px;
      "
      @click="checkBoxdialog = true"
      v-if="checkBoxData.length > 0"
    >
      <!-- <i class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></i> -->
      <el-badge :value="checkBoxNumber">
        <img
          src="../../../static/img/selects.png"
          style="width: 70%; height: 70%; font-size: 40px"
        />
        <!-- <span class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></span> -->
      </el-badge>
    </div>
    <!-- 显示购物车列表 -->
    <el-dialog
      title="已选择设备"
      :visible.sync="checkBoxdialog"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-button
        type="primary"
        size="mini"
        @click="removeAllCheckbox"
        style="margin-top: -30px; float: left"
        >清空内容</el-button
      >
      <el-table
        :data="checkBoxData"
        v-if="checkBoxNumber > 0"
        :header-cell-style="{ background: '#eff3f6' }"
        style="padding-top: 5px"
      >
      <el-table-column
            :label="lable.index"
            type="index"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="id"
            :label="lable.id"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-link
                :underline="false"
                @click="onClick(scope.row)"
                style="color: #4095e5; text-decoration: none"
              >
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="glbh"
            :label="lable.glbh"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="zcmc"
            :label="lable.zcmc"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="ssdw"
            :label="lable.ssdw"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="applyTime"
            :label="lable.applyTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="userName"
            :label="lable.userName"
            width="100PX"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="companyName"
            :label="lable.companyName"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="reason"
            :label="lable.reason"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="wz"
            :label="lable.statue"
            width="100PX"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.statue == '1'"
                style="color: #4095e5"
                v-text="scope.row.wz"
              ></span>
              <span
                v-else-if="scope.row.statue == '2'"
                style="color: gray"
                v-text="scope.row.wz"
              ></span>
              <span
                v-else-if="scope.row.statue == '3'"
                style="color: yellowgreen"
                v-text="scope.row.wz"
              ></span>
              <span
                v-else-if="scope.row.statue == '4'"
                style="color: orange"
                v-text="scope.row.wz"
              ></span>
              <span
                v-else-if="scope.row.statue == '5'"
                style="color: rgb(204, 169, 13)"
                v-text="scope.row.wz"
              ></span>

              <span
                v-else-if="scope.row.statue == '0'"
                style="color: red"
                v-text="scope.row.wz"
              ></span>
              <span
                v-else-if="scope.row.statue == '1.5'"
                style="color: #4095e5"
                v-text="scope.row.wz"
              ></span>
            </template>
          </el-table-column>
        <el-table-column label="操作" style="text-decoration: none">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="removeThisData(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :title="previewTitle"
      :visible.sync="docxdialog"
      style="margin-top: -50px"
      width="63%"
    >
      <FilePreview ref="filePreview" />
    </el-dialog>
  </div>
</template>
<script>
import {
  selectAllMaintenance,
  addMaintenance,
  upload,
  findByIdFile,
  delByIdFile,
  delByIdDeviceMaintenance,
  updateMaintenance,
  findByIdWorkflow,
  selectAllstatus,
  auditMaintenance,
  cxqx,
  excelWBExport,
  findByRoleUser,
  cxqrqx,
  cxlrqx,
  notarizeMaintenance,
  inputMaintenance,
  findByModule,
  withdrawDeviceMaintenance,
  findByUserIdCompanyTree
} from "../../api/api";

import DeviceComponent from "../../components/common/DeviceComponent.vue";
import FilePreview from "../../components/preview/FilePreview.vue";

export default {
  name: "Maintenance",
  components: {
    DC: DeviceComponent,
    FilePreview: FilePreview,
  },

  data() {
    return {
      _this: this,
      deviceInfo: {
        date: [],
        content: "",
        state: "",
      },
      companyTree:[],
      props: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
      },
      checkBoxdialog: false,
      checkBoxData: [],
      checkBoxNumber: 0,
      lable: {},
      show: {
        tj: false,
        wg: false,
        sc: false,
        sh: false,
        lr: false,
        qr: false,
        dctz: false,
        ch: false,
        qjsc: false,
      },
      userinfo: {},
      docxdialog: false,
      previewTitle: "",
      pj: ["非常差", "差", "一般", "好", "非常好"],
      activeName: "first",
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      maintenanceData: [],
      options: [],
      form: {
        name: "",
        fileDesc: "",
      },
      docxdialog: false,
      previewTitle: "",
      fileData: [],
      fileList: [],
      // 不支持多选
      multiple: false,
      formData: "",
      multipleSelection: [],
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      dialogFormVisible4: false,
      dialogFormVisible5: false,
      innerVisible: false,
      innerVisible1: false,
      innerVisible2: false,
      questionForm: {
        reason: "",
        maintenanceType: "",
        glbh: "",
        zcmc: "",
        ssdw: "",
        deviceId: "",
      },
      resultOptions: [
        {
          value: "已修复",
          label: "已修复",
        },
        {
          value: "部分修复",
          label: "部分修复",
        },
        {
          value: "未修复",
          label: "未修复",
        },
      ],
      optionsUser: [],
      tableData: [],
      wxry: {
        jcwb: [],
        bgwb: [],
      },
    };
  },
  methods: {
    getRowKeys(row) {
      return row.id;
    },
    //清空所有内容
    removeAllCheckbox() {
      this.checkBoxData = [];
      this.checkBoxNumber = this.checkBoxData.length;
      this.$refs.multipleTable.clearSelection(); //清除所有选中复选框
      this.checkBoxdialog = false;
    },
    //获取复选框选中数据
    changeCheckBoxValue(val) {
      console.log(val);
      this.checkBoxData = val;
      this.checkBoxNumber = this.checkBoxData.length;
    },
    //移除一条选中内容
    removeThisData(row) {
      let newCheckBoxData = [];
      for (var i = 0; i < this.checkBoxData.length; i++) {
        if (this.checkBoxData[i].id != row.id) {
          // debugger
          newCheckBoxData.push(this.checkBoxData[i]);
        }
      }
      this.checkBoxData = newCheckBoxData;
      if (this.checkBoxData.length > 0) {
        this.$refs.multipleTable.store.states.selection.map((item, index) => {
          if (item.id === row.id) {
            this.$refs.multipleTable.store.states.selection.splice(index, 1);
          }
        });
      } else {
        this.$refs.multipleTable.clearSelection(); //清除所有选中复选框
        this.checkBoxdialog = false;
      }
      this.checkBoxNumber = this.checkBoxData.length;
    },
    //根据id删除维保信息
    withdrawMaintenance(row) {
      this.$confirm("此操作将撤回该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var userinfo = JSON.parse(localStorage.getItem("user"));

        var map = {
          id: row.id,
          userId: userinfo.userId,
        };
        withdrawDeviceMaintenance(map).then((datas) => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error",
            });
          } else if (status == 200) {
            this.findAll();
            this.$message({
              message: "撤回成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error",
            });
          }
        });
      });
    },
    downloading(scop) {
      // debugger
      this.downloadUtil.downloadFile(scop.path, scop.name);
    },
    findAllClick() {
      this.pageIndex = 1;
      this.findAll();
    },
    submitLuru() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      this.questionForm.userId = userinfo.userId;
      inputMaintenance(this.questionForm).then((datas) => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          this.findAll();
          this.dialogFormVisible5 = false;
          this.questionForm = {};
          this.$message({
            message: "录入成功",
            type: "success",
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
    },
    selectlrqx() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.error("只能选择一条记录"); // .....失败信息
      } else if (currentSelect.length == 1) {
        if (currentSelect[0].statue == 2) {
          var userinfo = JSON.parse(localStorage.getItem("user"));

          var map = {
            id: currentSelect[0].id,
            userId: userinfo.userId,
          };
          cxlrqx(map).then((datas) => {
            // debugger
            let { status, message } = datas;
            if (status == 400) {
              this.$message({
                message: message,
                type: "error",
              });
            } else if (status == 200) {
              this.questionForm = {};
              this.questionForm = currentSelect[0];
              this.$set(
                this.questionForm,
                `startTime`,
                this.timeUtil.timeFormat(new Date())
              );
              this.$set(
                this.questionForm,
                `endTime`,
                this.timeUtil.timeFormat(new Date())
              );
              this.$set(this.questionForm, `result`, "已修复");
              var a = [];
              if (this.questionForm.person != null) {
                a = this.questionForm.person.split(",");
              }
              this.questionForm.list = a;
              this.findByIdfile(this.questionForm.id);
              this.dialogFormVisible5 = true;
            } else {
              this.$message({
                message: "请求错误",
                type: "error",
              });
            }
          });
        } else {
          this.$message.error("该信息不属于待录入状态"); // .....失败信息
        }
      } else {
        this.$message.error("请选择设备"); // .....失败信息
      }
    },
    submitNotarize() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      this.questionForm.userId = userinfo.userId;
      notarizeMaintenance(this.questionForm).then((datas) => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          this.dialogFormVisible4 = false;
          this.findAll();
          this.$message({
            message: "确认成功",
            type: "success",
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
    },
    selectChangeHandle() {
      this.$forceUpdate();
    },
    selectQx() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.error("只能选择一条记录"); // .....失败信息
      } else if (currentSelect.length == 1) {
        if (currentSelect[0].statue == 3) {
          var userinfo = JSON.parse(localStorage.getItem("user"));

          var map = {
            id: currentSelect[0].id,
            userId: userinfo.userId,
          };
          cxqrqx(map).then((datas) => {
            // debugger
            let { status, message } = datas;
            if (status == 400) {
              this.$message({
                message: message,
                type: "error",
              });
            } else if (status == 200) {
              this.questionForm = {};
              this.questionForm = currentSelect[0];
              var a = [];
              if (this.questionForm.person != null) {
                a = this.questionForm.person.split(",");
              }
              this.questionForm.list = a;
              this.findByIdfile(this.questionForm.id);
              this.dialogFormVisible4 = true;
            } else {
              this.$message({
                message: "请求错误",
                type: "error",
              });
            }
          });
        } else {
          this.$message.error("该信息不属于待确认状态"); // .....失败信息
        }
      } else {
        this.$message.error("请选择设备"); // .....失败信息
      }
    },
    //审核通过
    auidt() {
      let map = {
        id: this.questionForm.id,
        list: this.questionForm.list,
        workflowContent: this.questionForm.workflowContent,
        sout: 0,
      };
      this.audit(map);
    },
    //审核驳回
    noAuidt() {
      let map = {
        id: this.questionForm.id,
        list: this.questionForm.list,
        workflowContent: this.questionForm.workflowContent,
        sout: 1,
      };
      this.audit(map);
    },
    //审核
    audit(row) {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      row.userId = userinfo.userId;
      auditMaintenance(row).then((datas) => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "warning",
          });
        } else if (status == 200) {
          this.dialogFormVisible3 = false;
          this.findAll();
          this.$message({
            message: "审核成功",
            type: "success",
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
    },
    //确认审批权限
    selectshqx() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.error("只能选择一条记录"); // .....失败信息
      } else if (currentSelect.length == 1) {
        if ((currentSelect[0].statue == 1) | (currentSelect[0].statue == 1.5)) {
          var userinfo = JSON.parse(localStorage.getItem("user"));
          var map = {
            id: currentSelect[0].id,
            userId: userinfo.userId,
          };
          cxqx(map).then((datas) => {
            // debugger
            let { status, message } = datas;
            if (status == 400) {
              this.$message({
                message: message,
                type: "error",
              });
            } else if (status == 200) {
              this.findByIdWork(currentSelect[0].id);
              this.questionForm = {};
              this.questionForm = currentSelect[0];
              if (this.questionForm.yjfl == "P0001") {
                this.optionsUser = this.wxry.bgwb;
              }
              if (this.questionForm.yjfl == "P0002") {
                this.optionsUser = this.wxry.jcwb;
              }
              var a = [];
              if (this.questionForm.person != null) {
                a = this.questionForm.person.split(",");
              }
              this.questionForm.list = a;
              this.dialogFormVisible3 = true;
            } else {
              this.$message({
                message: "请求错误",
                type: "error",
              });
            }
          });
        } else {
          this.$message.error("该信息不属于待审批状态"); // .....失败信息
        }
      } else {
        this.$message.error("请选择设备"); // .....失败信息
      }
    },
    yulan(row) {
      if (
        row.path.substring(row.path.lastIndexOf(".") + 1) == "jpg" ||
        row.path.substring(row.path.lastIndexOf(".") + 1) == "png" ||
        row.path.substring(row.path.lastIndexOf(".") + 1) == "jpeg"
      ) {
        this.previewTitle = "图片预览";
      } else {
        this.previewTitle = "文件预览";
      }
      this.docxdialog = true;
      this.$nextTick(() => {
        this.$refs.filePreview.showView(row.path);
      });
      // this.downloadUtil.preview(row.path)
    },
    derive() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        state: this.deviceInfo.state,
        userId: userinfo.userId,
      };
      if (this.checkBoxData.length > 0) {
        map["ids"] = this.checkBoxData.map((item) => item.id).join();
      }else{
        map["ids"] = ""
      }
      excelWBExport(map).then((datas) => {
        const blob = new Blob([datas]);
        const dlink = document.createElement("a");
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const dlink = document.createElement("a");
          dlink.download = "维保台账.xlsx";
          dlink.style.display = "none";
          dlink.href = URL.createObjectURL(blob);
          document.body.appendChild(dlink);
          dlink.click();
          URL.revokeObjectURL(dlink.href); // 释放URL 对象
          document.body.removeChild(dlink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, "维保台账.xlsx");
        }
      });
    },
    transferValue(outData) {
      this.questionForm.zcmc = outData.zcmc;
      this.questionForm.ssdw = outData.ssdw;
      this.questionForm.deviceId = outData.id;
      this.questionForm.glbh = outData.glbh;
    },
    //根据id删除维保信息
    delMaintenance(row) {
      this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var userinfo = JSON.parse(localStorage.getItem("user"));

        var map = {
          id: row.id,
          userId: userinfo.userId,
        };
        delByIdDeviceMaintenance(map).then((datas) => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error",
            });
          } else if (status == 200) {
            this.findAll();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error",
            });
          }
        });
      });
    },
    //添加数据
    submit() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      this.questionForm.userId = userinfo.userId;
      addMaintenance(this.questionForm).then((datas) => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          this.dialogFormVisible = false;
          this.findAll();
          this.$message({
            message: "添加成功",
            type: "success",
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
    },
    cancel1() {
      this.dialogFormVisible1 = false;
      this.findAll();
    },

    //根据id修改数据
    submitUpdate() {
      if (this.questionForm.statue == 1.5) {
        this.questionForm.statue = 1;
      }
      var userinfo = JSON.parse(localStorage.getItem("user"));
      this.questionForm.userId = userinfo.userId;
      // this.questionForm.fileIds = a1;
      updateMaintenance(this.questionForm).then((datas) => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          this.dialogFormVisible1 = false;
          this.findAll();
          this.$message({
            message: "更改成功",
            type: "success",
          });
          // this.fileData=[];
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
    },
    //查找所有维保信息
    findAll() {
      var userinfo = JSON.parse(localStorage.getItem("user"));

      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        state: this.deviceInfo.state,
        userId: userinfo.userId,
        companyCode:null
      };
      if(this.deviceInfo.companyCode!=null){
        map.companyCode=this.deviceInfo.companyCode[this.deviceInfo.companyCode.length-1] 
      }
      selectAllMaintenance(map).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) {
            this.data = [];
          } else {
            this.data = data;
          }
          
          this.maintenanceData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          console.log(this.maintenanceData  )
          this.total = this.data.length;
        }
      });
    },
    //设置测试数据
    handleCreate() {
      let id = "WB" + +new Date();
      this.questionForm = {
        reason: "",
        maintenanceType: "",
        glbh: "",
        zcmc: "",
        ssdw: "",
        deviceId: "",
        id: id,
      };
      this.fileData = [];
      // this.findByIdfile(this.questionForm.id);
      this.dialogFormVisible = true;
    },
    //根据id查找文件
    findByIdfile(id) {
      findByIdFile(id).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.fileData = data;
        }
      });
    },
    updateClick(row) {
      this.questionForm = {};
      this.questionForm = row;

      this.findByIdfile(row.id);
      this.dialogFormVisible1 = true;
    },
    //跳转 标记
    onClick(row) {
      if (row.statue == 0 && this.show.xg) {
        this.questionForm = {};
        this.questionForm = row;
        this.findByIdfile(row.id);
        this.dialogFormVisible1 = true;
      } else if ((row.statue == 1 || row.statue == 1.5) && this.show.sh) {
        row.statue = 1;
        var userinfo = JSON.parse(localStorage.getItem("user"));
        var map = {
          id: row.id,
          userId: userinfo.userId,
        };
        cxqx(map).then((datas) => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.selectClick(row);
          } else if (status == 200) {
            this.findByIdWork(row.id);
            this.questionForm = {};
            this.questionForm = row;
            if (this.questionForm.yjfl == "P0001") {
              this.optionsUser = this.wxry.bgwb;
            }
            if (this.questionForm.yjfl == "P0002") {
              this.optionsUser = this.wxry.jcwb;
            }
            var a = [];
            if (this.questionForm.person != null) {
              a = this.questionForm.person.split(",");
            }
            this.questionForm.list = a;
            this.dialogFormVisible3 = true;
          } else {
            this.$message.error("请求错误");
          }
        });
      } else if (row.statue == 2 && this.show.lr) {
        var userinfo = JSON.parse(localStorage.getItem("user"));

        var map = {
          id: row.id,
          userId: userinfo.userId,
        };
        cxlrqx(map).then((datas) => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.selectClick(row);
          } else if (status == 200) {
            this.questionForm = {};
            this.questionForm = row;
            this.$set(
              this.questionForm,
              `startTime`,
              this.timeUtil.timeFormat(new Date())
            );
            this.$set(
              this.questionForm,
              `endTime`,
              this.timeUtil.timeFormat(new Date())
            );
            this.$set(this.questionForm, `result`, "已修复");
            var a = [];
            if (this.questionForm.person != null) {
              a = this.questionForm.person.split(",");
            }
            this.questionForm.list = a;
            this.findByIdfile(this.questionForm.id);
            this.dialogFormVisible5 = true;
          } else {
            this.$message.error("请求错误");
          }
        });
      } else if (row.statue == 3 && this.show.qr) {
        var userinfo = JSON.parse(localStorage.getItem("user"));
        var map = {
          id: row.id,
          userId: userinfo.userId,
        };
        cxqrqx(map).then((datas) => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.selectClick(row);
          } else if (status == 200) {
            this.questionForm = {};
            this.questionForm = row;
            var a = [];
            if (this.questionForm.person != null) {
              a = this.questionForm.person.split(",");
            }
            this.questionForm.list = a;
            this.findByIdfile(this.questionForm.id);
            this.dialogFormVisible4 = true;
          } else {
            this.$message.error("请求错误");
          }
        });
      } else {
        this.selectClick(row);
      }
    },
    //详情页面
    selectClick(row) {
      this.questionForm = {};
      this.questionForm = row;
      this.findByIdfile(row.id);
      this.findByIdWork(row.id);
      this.dialogFormVisible2 = true;
    },

    //根据id查找业务流程信息
    findByIdWork(row) {
      findByIdWorkflow(row).then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.tableData = data;
        }
      });
    },
    //删除检定附件信息
    DFile(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delByIdFile(row.id).then((datas) => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error",
            });
          } else if (status == 200) {
            this.findByIdfile(this.questionForm.id);
            this.$message({
              message: message,
              type: "success",
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error",
            });
          }
        });
      });
    },
    //文件上传
    onSubmit() {
      if (this.fileList[0] == null) {
        this.$message.error("请选择上传的文件"); // .....失败信息
      } else {
        var formData = new FormData();
        formData.append("file", this.fileList[0].raw); //拿到存在fileList的文件存放到formData中
        //下面数据是我自己设置的数据,可自行添加数据到formData(使用键值对方式存储)
        formData.append("name", this.form.name);
        formData.append("fileDesc", this.form.fileDesc);
        formData.append("number", this.questionForm.id);
        var userinfo = JSON.parse(localStorage.getItem("user"));
        formData.append("userId", userinfo.userId);
        // debugger
        upload(formData).then((datas) => {
          let { status, message, data } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error",
            });
          } else if (status == 200) {
            this.fileData.push(data);
            this.$message({
              message: "上传成功",
              type: "success",
            });
            this.innerVisible = false;
            this.innerVisible1 = false;
            this.innerVisible2 = false;
          } else {
            this.$message({
              message: "请求错误",
              type: "error",
            });
          }
          this.form.fileDesc = "";
          this.form.name = "";
          this.fileList = [];
        });
      }
    },

    //点击上传文件触发的额外事件,清空fileList
    delFile() {
      this.fileList = [];
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    //自定义上传文件
    uploadFile(file) {
      this.formData.append("file", file.file);
    },
    //删除文件
    handleRemove(file, fileList) {},
    // 点击文件
    handlePreview(file) {},

    findAllType() {
      selectAllstatus().then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].statusType == "维保管理") {
              this.options.push({
                name: data[i].statusName,
                id: data[i].statue,
              });
            }
          }
        }
      });
    },
    //前台分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.maintenanceData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.maintenanceData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    findRoleUser() {
      findByRoleUser().then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.wxry = data;
        }
      });
    },
    getFrom() {
      let row = JSON.parse(sessionStorage.getItem("wbData"));
      if (row != null) {
        this.selectClick(row);
        sessionStorage.removeItem("wbData");
      }
    },
    findLable() {
      findByModule("维保管理").then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
   getCompanyTree() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var  companyCode='';
      if (userinfo.userRole == 1 || (userinfo.fjqx != null && (userinfo.fjqx.indexOf ("3")!=-1||userinfo.fjqx.indexOf ("4")!=-1))) {
        companyCode="-1"
      }else{
        companyCode=userinfo.companyCode
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.companyTree = this.getTreeData(data);
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].zcompany);
        }
      }
      return data;
    },
  },
  created() {
    this.getCompanyTree();
    this.findLable();
    this.findAll();
    this.findAllType();
    this.findRoleUser();
    this.getFrom();
    var userinfo = JSON.parse(localStorage.getItem("user"));
    this.userinfo = userinfo;
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "101") {
        this.show.tj = true;
      }
      if (i == "102") {
        this.show.xg = true;
        // console.log('测试了');
      }
      if (i == "103") {
        this.show.sc = true;
      }
      if (i == "104") {
        this.show.sh = true;
      }
      if (i == "105") {
        this.show.lr = true;
      }
      if (i == "106") {
        this.show.qr = true;
      }
      if (i == "140") {
        this.show.dctz = true;
      }
      if (i == "198") {
        this.show.ch = true;
      }
      if (i == "200") {
        this.show.qjsc = true;
      }
    });
  //  var bool= true &&
  //                this.show.xg &&
  //                 (userinfo.userId == userinfo.userId);
  //                 console.log(bool);
  },
};
</script>
<style >
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style scoped>
.el-input {
  width: 100%;
}

.btn {
  float: left;
  margin-left: 5px;
}
</style> 



// WEBPACK FOOTER //
// src/views/maintenance/Maintenance.vue